import styled from 'styled-components'

const Example = styled.pre`
  margin-top: 10px;
  border: solid 5px #14B300;
  border-width: 0 0 0 5px;
  border-radius: 0;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-family: sans-serif;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #fff;
`

export default Example
